export default {
	firstname: {
		wrapper: 'col-md-6',
		component: 'text-input',
		label: 'First Name',
		newEntryReset: true,
	},
	surname: {
		wrapper: 'col-md-6',
		component: 'text-input',
		label: 'Last Name',
		newEntryReset: true,
	},
	company: {
		wrapper: 'col-md-6',
		component: 'text-input',
		label: 'Company',
	},
	position: {
		wrapper: 'col-md-6',
		component: 'text-input',
		label: 'Job Title',
		newEntryReset: true,
	},
	email: {
		wrapper: 'col-md-6',
		component: 'text-input',
		label: 'Email',
		newEntryReset: true,
	},
	ctry_code: {
		wrapper: 'col-4 col-md-2',
		component: 'text-input',
		label: 'Area Code',
		defaultValue: '+64',
		newEntryReset: true,
	},
	mobile: {
		wrapper: 'col-8 col-md-4',
		component: 'text-input',
		label: 'Mobile',
		newEntryReset: true,
	},
	website: {
		wrapper: 'col-12 website-field',
		component: 'text-input',
		label: 'Website',
		required: false,
	},
	address: {
		wrapper: 'col-12 address-field',
		component: 'address-finder-bundle',
		label: 'Enter your company postal address',
		required: true,
	},
};
